'use strict';

function sendWebviewEventToDevice(action, args) {
    const win = window;
    const params = JSON.stringify(Object.assign({}, {action: action}, args));
    if (win.webkit && win.webkit.messageHandlers && win.webkit.messageHandlers.mobileApp) { // iOS
        win.webkit.messageHandlers.mobileApp.postMessage(params);
    } else if (win.mobileApp) { // Android
        win.mobileApp.postMessage(params);
    } else {
        console.log("call to mobileApp.postMessage with parameter: " + params);
    }
}

// Interaction with mobile app

function sendCloseWebviewEventToDeviceWithArgs(status, cardInfo) {
    sendWebviewEventToDevice("closeWebview", {status: status, cardInfo: cardInfo});
}

function sendCloseWebviewEventToDeviceCloseOnly() {
    sendWebviewEventToDevice("goPreviousWebview");
    sendWebviewEventToDevice("closeWebview");
}

function sendCloseWebviewEventToDevice(status) {
    sendWebviewEventToDevice("closeWebview", {status: status});
}

function sendRequestMobileLinkToOpenBrowserToDevice(forwardLink, backwardLink) {
    sendWebviewEventToDevice("requestOpenInBrowser", {forwardLink: forwardLink, backwardLink: backwardLink});
}

function sendUserNotAuthenticatedEventToDevice() {
    sendWebviewEventToDevice("requestSignIn", {url: window.location.href});
}

function sendRequestMobileViewToDevice(view) {
    sendWebviewEventToDevice("requestMobileView", {view: view});
}

function sendRequestMobileCouponView() {
    sendRequestMobileViewToDevice("COUPON");
}

function sendRequestMobileFlyerView() {
    sendRequestMobileViewToDevice("FLYER");
}

function sendRequestMobileHomeView() {
    sendRequestMobileViewToDevice("HOME");
}

function sendRequestMobileAccountView() {
    sendRequestMobileViewToDevice("ACCOUNT");
}

function sendNewQtyInCartEventToDevice(nbItems) {
    sendWebviewEventToDevice("updateCartNbItems", {nbItems: nbItems});
}

function sendCartItemUpdateEventToDevice($product) {
    sendWebviewEventToDevice("updateCartItem", {product: extractCartItemDataForDevice($product)});
}

function sendFavoriteItemUpdateEventToDevice($product) {
    sendWebviewEventToDevice("updateFavoriteItem", {product: extractFavoriteItemDataForDevice($product)});
}

function sendErrorEventToDevice(errorStatusCode) {
    sendWebviewEventToDevice("closeWebview", {status: errorStatusCode});
}

function sendSessionExpirationToDevice(url) {
    sendWebviewEventToDevice("sessionExpiration", {url: url});
}

function sendWebviewReadyEventToDevice() {
    sendWebviewEventToDevice("webviewReady", {url: window.location.href});
}

function sendWebviewReloadCartToDevice() {
    sendWebviewEventToDevice("reloadCart", {url: window.location.href});
}

function sendWebviewChangeStatusOrder() {
    sendWebviewEventToDevice("reloadAppView");
}

function sendWebviewClearCachePostal() {
    sendWebviewEventToDevice("clearCacheBadPostal");
}

function sendWebviewAirMilesBalance(cashBalance, dreamBalance) {
    sendWebviewEventToDevice("airMilesBalance", {cashBalance: cashBalance, dreamBalance: dreamBalance});
}

function sendWebviewAirMilesMismatch() {
    sendWebviewEventToDevice("airmilesMismatchError");
}

// Webview frame properties
function sendChangeWebviewConfigToDevice(webviewType) {
    let webviewConfig = webviewProperties.hasOwnProperty(webviewType) ? webviewProperties[webviewType] : webviewProperties['default'];
    sendWebviewEventToDevice("changeWebViewConf", {status: webviewConfig});
}

function WebviewProperties(showNavigationBar, showBottomMenu, showBackButton, showSearchBar, showCloseButton) {
    this.showNavigationBar = !!showNavigationBar;
    this.showBottomMenu = !!showBottomMenu;
    this.showBackButton = !!showBackButton;
    this.showSearchBar = !!showSearchBar;
    this.showCloseButton = !!showCloseButton;
    this.title = '';
}

let webviewProperties = [];
webviewProperties['catalog'] = new WebviewProperties(true, true, true, true, false);
webviewProperties['serviceTimeslot'] = new WebviewProperties(false, false, false, false, false);
webviewProperties['pdp'] = new WebviewProperties(true, true, true, true, false);
webviewProperties['cart'] = new WebviewProperties(false, false, false, false, false);
webviewProperties['checkout'] = new WebviewProperties(false, false, false, false, false);
webviewProperties['orderConfirmation'] = new WebviewProperties(true, false, false, false, true);
webviewProperties['orderDetail'] = new WebviewProperties(true, false, false, false, true);
webviewProperties['accountAddress'] = new WebviewProperties(true, false, false, false, true);
webviewProperties['deliveryAddress'] = new WebviewProperties(true, false, false, false, true);
webviewProperties['substitutionPreferences'] = new WebviewProperties(true, false, true, false, false);
webviewProperties['paymentMethods'] = new WebviewProperties(true, false, true, false, false);
webviewProperties['unlimitedDeliveryPass'] = new WebviewProperties(true, false, true, false, false);
webviewProperties['newslettersConsents'] = new WebviewProperties(true, false, true, false, false);
webviewProperties['cardRegistration'] = new WebviewProperties(true, false, true, false, false);
webviewProperties['flyer'] = new WebviewProperties(false, true, false, false, false);
webviewProperties['registrationNewslettersConsents'] = new WebviewProperties(true, false, true, false, true);
webviewProperties['myMetroProfile'] = new WebviewProperties(true, false, false, false, true);
webviewProperties['default'] = new WebviewProperties(false, false, false, false, true);
webviewProperties['howItWorks'] = new WebviewProperties(true, false, false, false, true);
webviewProperties['cardRegistrationSuccess'] = new WebviewProperties(false, false, false, false, false);
webviewProperties['cartGenius'] = new WebviewProperties(false, true, false, false, false);

// Utils
function extractCartItemDataForDevice($product) {
    let sku = $product.attr('data-product-code') || null;
    let selectedOption = $product.find('[name=select_element]').find(':selected').val() || null;
    let entryNumber = $product.attr('data-cart-entry') != null ? +$product.attr('data-cart-entry') : null;
    let inCart = entryNumber != null;
    let qty = inCart ? +$product.find('.qty-addToCart').first().text() : 0;

    return {
        id: sku,
        entryNumber: entryNumber,
        inCart: inCart,
        selectedOption: selectedOption,
        quantity: qty
    };
}

function extractFavoriteItemDataForDevice($product) {
    let sku = $product.attr('data-product-code') || null;
    let selectedOption = $product.find('[name=select_element]').find(':selected').val() || null;
    let inFavourites = $product.find('.addToCartStarter').hasClass('is_favorite');
    let qty = inFavourites ? +$product.find('.qty-addToCart').first().text() : 0;

    return {
        id: sku,
        inFavourites: inFavourites,
        selectedOption: selectedOption,
        quantity: qty
    };
}

$(function () {
    if (isInWebview()) {
        sendWebviewReadyEventToDevice();
    }
});

$(document).on('click', 'a.open_in_nav', function (event) {
    if (isInWebview()) {
        event.preventDefault();
        const forwardLink = this.href;
        const backwardLink = null;
        sendRequestMobileLinkToOpenBrowserToDevice(forwardLink, backwardLink);
    }
});